import { render, staticRenderFns } from "./AppPreloader.vue?vue&type=template&id=521a7bb8&scoped=true&"
import script from "./AppPreloader.vue?vue&type=script&lang=ts&"
export * from "./AppPreloader.vue?vue&type=script&lang=ts&"
import style0 from "./AppPreloader.vue?vue&type=style&index=0&id=521a7bb8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "521a7bb8",
  null
  
)

export default component.exports